import { useCustomTranslation } from '../../../../../hooks';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCustomToast } from '@nexelem/snackbar';
import { api, AutoAssignWorkersRequest } from '@nexelem/api';
import { closeAutoAssigmentModal } from './AutoAssignmentModal';
import { GRAPHNE_RESOURCE_GROUP_LIST_TIMEFRAME_KEY } from '../../../../../queryHooks/productionPlanHooks/useGraphneResourcesGroupTimeframe';

export const useAssignAllWorkersMutation = () => {
  const queryClient = useQueryClient();
  const displayToast = useCustomToast();
  const { tWrapper } = useCustomTranslation('products.productionPlan.autoAssigment');
  return useMutation({
    mutationFn: (payload: AutoAssignWorkersRequest) =>
      api.postBackProductionLotAutoAssignWorkers({
        autoAssignWorkersRequest: payload,
      }),
    onSuccess: () => {
      closeAutoAssigmentModal();
      queryClient.invalidateQueries({ queryKey: [GRAPHNE_RESOURCE_GROUP_LIST_TIMEFRAME_KEY] });
      displayToast({
        toastType: 'success',
        message: tWrapper('assignSuccess'),
      });
    },
    onError: () => {
      displayToast({
        toastType: 'error',
        message: tWrapper('assignError'),
      });
    },
  });
};
